// See services/sosInventoryService/README.md for information about the structure
// of schema.js files.
export const FIELDS_TO_TRANSFORM = {
  DECIMAL_FIELDS: [],
  MONEY_FIELDS: ["cost", "revenue"],
  DATE_FIELDS: ["txnDate"],
  DATETIME_FIELDS: [],
  NON_UTC_DATETIME_FIELDS: [],
};
